import request from '@/http/request'
import {
  getBanner,
  getSelectPlan,
  getDataList,
  getAuditInfo,
  getSignAndPayList,
  querySessionAvailable,
  queryTotalData,
  querySignCount,
  queryPhotoList,
  querySpotCount,
  queryCourseCount,
  queryExamIpAddress,
  getScreenPlanList,
  getPlanAllSession,
  batchList,
  getPlanReviewCourse,
  getScreenReviewTotal,
  getScreenReviewDateCount,
  getScreenReviewCourseList,
  getScreenReviewCountList,
  getScreenReviewDurationList,
  getScreenReviewScoreSection,
  getScreenReviewInfoList,
  querySessionNext,
  queryDatetimeCount
} from '@/http/api'

export const queryDatetimeCountApi = (data) => {
  return request({
    url: queryDatetimeCount,
    data
  })
}

export const querySessionNextApi = (data) => {
  return request({
    url: querySessionNext,
    data
  })
}

export const getScreenReviewInfoListApi = (data) => {
  return request({
    url: getScreenReviewInfoList,
    data
  })
}

export const getScreenReviewScoreSectionApi = (data) => {
  return request({
    url: getScreenReviewScoreSection,
    data
  })
}

export const getScreenReviewDurationListApi = (data) => {
  return request({
    url: getScreenReviewDurationList,
    data
  })
}

export const getScreenReviewCountListApi = (data) => {
  return request({
    url: getScreenReviewCountList,
    data
  })
}

export const getScreenReviewCourseListApi = (data) => {
  return request({
    url: getScreenReviewCourseList,
    data
  })
}

export const getScreenReviewDateCountApi = (data) => {
  return request({
    url: getScreenReviewDateCount,
    data
  })
}

export const getScreenReviewTotalApi = (data) => {
  return request({
    url: getScreenReviewTotal,
    data
  })
}

export const getPlanReviewCourseApi = (data) => {
  return request({
    url: getPlanReviewCourse,
    data
  })
}

export const getSelectPlanApi = (data) => {
  return request({
    url: getSelectPlan,
    data
  })
}

export const batchListApi = (data) => {
  return request({
    url: batchList,
    data
  })
}

export const getPlanAllSessionApi = (data) => {
  return request({
    url: getPlanAllSession,
    data
  })
}

export const queryExamIpAddressApi = (data) => {
  return request({
    url: queryExamIpAddress,
    data
  })
}

export const queryCourseCountApi = (data) => {
  return request({
    url: queryCourseCount,
    data
  })
}

export const querySpotCountApi = (data) => {
  return request({
    url: querySpotCount,
    data
  })
}

export const queryPhotoListApi = (data) => {
  return request({
    url: queryPhotoList,
    data
  })
}

export const querySignCountApi = (data) => {
  return request({
    url: querySignCount,
    data
  })
}

export const queryTotalDataApi = (data) => {
  return request({
    url: queryTotalData,
    data
  })
}

export const querySessionAvailableApi = (data) => {
  return request({
    url: querySessionAvailable,
    data
  })
}

export const getSignAndPayListApi = (data) => {
  return request({
    url: getSignAndPayList,
    data
  })
}

export const getAuditInfoApi = (data) => {
  return request({
    url: getAuditInfo,
    data
  })
}

export const getDataListApi = (data) => {
  return request({
    url: getDataList,
    data
  })
}

export const getBannerApi = (data) => {
  return request({
    url: getBanner,
    data
  })
}

export const getScreenPlanListApi = (data) => {
  return request({
      url: getScreenPlanList,
      data
  })
}